import { Reply } from 'generated/graphql';
import { randomId } from '@client/new/helpers/id';

type Props = {
  text: string;
  userId: number;
  username: string;
  email: string;
};

export const createDummyReply = ({
  text,
  userId,
  username,
  email,
}: Props): Reply => ({
  id: `optimistic-${randomId()}`,
  createdAt: new Date(),
  edited: false,
  isSensitiveContent: false,
  reactions: [],
  text,
  author: {
    id: userId,
    badges: ['own'],
    profilePicture: '',
    username,
    email,
    marketing: false,
  },
});
